import(/* webpackMode: "eager" */ "/vercel/path0/app/paper/create/page.tsx");
